<template>
<div >
  <div class="form-group_">
    <label v-if="!props.label" for="store"><strong>SEDE</strong></label>
    <label v-else for="store"><strong>{{ props.label }}</strong></label>
    <div class="input-group">
    <select id="store_select" :required="props.required" :disabled="!props.isActive" @change="$emit('update',storeId,$event)" class="form-control" v-model="storeId" >
      <option v-if="props.optionBase" value="0"> -- TUTTE LE SEDI -- </option>  
      <option v-for="(item,index) in items" :value="item.storeId" :key="index">{{item.store}}</option>        
    </select>
      <a v-if="1==0" @click="getData()" class="btn btn-secondary" data-toggle="tooltip" title="refresh">
        <i v-if="!spinner" class="fas fa-sync-alt" aria-hidden="true"></i>
        <div v-else class="spinner-border spinner-border-sm" role="status">
          <span class="sr-only">Loading...</span>
      </div>
      </a>  
      </div>
  </div>  
</div>


</template>
<script>
import api from '@/api'

import { mapGetters }    from 'vuex';

export default {
  props : ['props'] , 
  components: {},
  data() {
    return {

      storeId                : 0,
      items                  : [],
      spinner                : false,
      

   
    };
  },
  computed :{
    ...mapGetters(['company']),
   
  },
  mounted: function() {
  
  },
  created: function() {
     // this.storeId = this.Id
      this.getData()
  },
  methods: 
  {
    async getData()
    {
      
      const sp   = {'sp'        : 'spStoresCompany'}      
      const data = {'companyId' : this.company.Id}
      const json  = Object.assign(data, sp);
      this.spinner = true
      await api.post(json).then(res => {
          if(res.status==200)
            {
              this.items = res.data.recordsets[0]      
              this.storeId = this.props.Id           
            }
           else if(res.status==500)
           {
                console.log(res.data)
                                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });



    },
  
    
    
  
}

}
</script>
<style scoped>

</style>